import { VariantType } from "@/shared/hooks/popup-snackbar-hook";
import { HttpStatusCode } from "./http-errors";
import { ROUTES } from "@/core/router/routes";

type ErrorAction = {
  message: string;
  severity: VariantType;
  callback?: () => void;
};

export const errorConfig: Record<HttpStatusCode | number, ErrorAction> = {
  0: {
    message: "error:networkError",
    severity: VariantType.ERROR
  },
  [HttpStatusCode.BAD_REQUEST]: {
    message: "error:badRequest",
    severity: VariantType.ERROR
  },
  [HttpStatusCode.UNAUTHORIZED]: {
    message: "error:unauthorized",
    severity: VariantType.ERROR,
    callback: () => {
      // Supplier/share anonymous sessions intentionally use "norefresh".
      // Avoid hard redirect to sign-in for those flows.
      if (localStorage.getItem("refreshToken") === "norefresh") {
        return;
      }
      localStorage.removeItem("accessToken");
      window.location.href = `/${ROUTES.Auth.Root}/${ROUTES.Auth.SignIn}`;
    }
  },
  [HttpStatusCode.FORBIDDEN]: {
    message: "error:forbidden",
    severity: VariantType.ERROR
  },
  [HttpStatusCode.METHOD_NOT_ALLOWED]: {
    message: "error:methodNotAllowed",
    severity: VariantType.ERROR
  },
  [HttpStatusCode.CONFLICT]: {
    message: "error:conflict",
    severity: VariantType.ERROR
  },
  [HttpStatusCode.NOT_FOUND]: {
    message: "error:notFound",
    severity: VariantType.WARNING
  },
  [HttpStatusCode.INTERNAL_SERVER]: {
    message: "error:internalServer",
    severity: VariantType.ERROR
  },
  [HttpStatusCode.SERVICE_UNAVAILABLE]: {
    message: "error:serviceUnavailable",
    severity: VariantType.ERROR
  }
};
